import { render, staticRenderFns } from "./UploadFileScreen.vue?vue&type=template&id=5a5038f8&"
import script from "./UploadFileScreen.vue?vue&type=script&lang=ts&"
export * from "./UploadFileScreen.vue?vue&type=script&lang=ts&"
import style0 from "./UploadFileScreen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports